/* OsLinkEnableComponent.js */

"use strict";

const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl
    .DefaultColumnComponent;
const Renderer = require("./OsLinkEnableRenderer");
const _ = require("lodash");

class IotOsLinkEnableComponent extends DefaultColumnComponent {
    constructor(value, context) {
        super(value);
        this._value = value;
        this._context = context;
        this._platformId = context.platformId;
        this._platformDetails = context.platformDetails || {};
        this._platformEntityDef = context.platformEntityDef;
        this._platform = context.platformDetails._odmOsPlatform || {};
        this._onIgnoreLinkIdsChanged = this._onIgnoreLinkIdsChanged.bind(this);
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {
        if (this._platform) {
            this.unregisterplatformListeners();
        }
    }

    registerplatformListeners() {
        this._platform.on("IgnoreLinkIdsPropertyUpdated", this._onIgnoreLinkIdsChanged);
    }

    unregisterplatformListeners() {
        this._platform.removeListener("IgnoreLinkIdsPropertyUpdated", this._onIgnoreLinkIdsChanged);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._value = undefined;
        this._context = undefined;
        this._platformId = undefined;
        this._platformDetails = undefined;
        this._platformEntityDef = undefined;
        this._platform = undefined;
        this._onIgnoreLinkIdsChanged = undefined;
        return prom;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onIgnoreLinkIdsChanged() {
        this.setOsLinkEnable(this.getEnableValue());
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    setValue(newVal) {
        if (!_.isUndefined(newVal)) {
            this._value = newVal;
            this.setOsLinkEnable(this.getEnableValue());
        }
    }

    getValue() {
        return this.getEnableValue();
    }

    setOsLinkEnable(newVal) {
        this.emit("OsLinkEnable", newVal);
        return this;
    }

    async enableLink(val) {
        try {
            const platform = await this._platformEntityDef.loadOdmOsPlatform(
                this._platform.tenantId,
                this._platformId
            );
            const ignoreLinkIds = platform.getIgnoreLinkIds() || [];

            if (val) {
                _.pull(ignoreLinkIds, this._value.id);
            } else {
                ignoreLinkIds.push(this._value.id);
            }

            platform.setIgnoreLinkIds(ignoreLinkIds);

            await platform.update();
        } catch (error) {
            console.error("Failed to update link enable status:", error);
            throw error;
        }
    }

    getEnableValue() {
        if (!this._value) {
            return false;
        }
        const linkId = this._value.id;
        const ignoreLinkIds = this._platform.getIgnoreLinkIds() || [];
        return !_.includes(ignoreLinkIds, linkId);
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = IotOsLinkEnableComponent;
